import * as moment from 'moment';
import { MINIMUM_SIGNUP_AGE, VIEWPORT_WIDTH_DESKTOP } from './ff-constants';

require('bootstrap-datepicker');

const screenObject = window.screen;

const dateField = $('#id_date_of_birth.dateinput');

if (screenObject.width > VIEWPORT_WIDTH_DESKTOP) {
  const dobPicker = dateField
    .datepicker({
      format: 'yyyy-mm-dd',  
      orientation: 'bottom',
      endDate: '-18y',
      defaultViewDate: '-18y'
    })
    .attr('type', 'text');

  dobPicker.datepicker('update');
} else {
  let minimumAge = moment()
    .subtract(MINIMUM_SIGNUP_AGE, 'years')
    .format('YYYY-MM-DD');
  dateField.attr('max', minimumAge);
}
